// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"87123f23","488":"94ba7e7c"}[chunkId] + ".chunk.js";
};